const notificationTypes = {
  Load: {
    icon: "ic_cargo-out",
    color: "var(--glz-color-success)",
  },
  Truck: {
    icon: "ic_truck-out",
    color: "var(--glz-color-warning)",
  },
  Passport: {
    icon: "ic_star-out",
    color: "var(--glz-color-stars-good)",
  },
  Finance: {
    icon: "ic_coin-out",
    color: "var(--glz-color-neutral-tone-5)",
  },
  Tender: {
    icon: "ic_tender-out",
    color: "var(--glz-color-neutral-tone-5)",
  },
  ATIDocs: {
    icon: "ic_ati-docs",
    color: "var(--glz-color-neutral-tone-5)",
  },
  Insurance: {
    icon: "ic_shield-out",
    color: "var(--glz-color-neutral-tone-5)",
  },
  Forum: {
    icon: "ic_partners-out",
    color: "var(--glz-color-neutral-tone-5)",
  },
  System: {
    icon: "ic_ati-logo-icon",
    color: "var(--glz-color-neutral-tone-5)",
  },
  TimeWindows: {
    icon: "ic_ati-logo-icon",
    color: "var(--glz-color-neutral-tone-5)",
  },
  Boards: {
    icon: "ic_open-board-out",
    color: "var(--glz-color-neutral-tone-5)",
  },
};

export { notificationTypes };
